import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';

export default function CatalogLink({ children, to, type = 'relative', target, className, activeLink }) {
  const { lang, setPagingDirection } = useContext(CatalogContext);
  let href = to;
  if (type === 'relative') {
    href = `/${lang}/${to}`;
  }

  const location = useLocation();
  let active = null;
  if (activeLink) {
    active = location.pathname === href;
  }

  return (
    <Link
      to={href}
      target={target}
      className={classNames(className && className, { active })}
      onClick={() => setPagingDirection('jump')}
    >
      {children}
    </Link>
  );
}
